import {Component, Input} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
    selector: 'lib-spinner',
    standalone: true,
    imports: [
        MatProgressSpinner
    ],
    templateUrl: './lib-spinner.component.html',
    styleUrl: './lib-spinner.component.scss'
})
export class LibSpinnerComponent {
    @Input() diameter: number = 20;
}
